import ScrollBooster from 'scrollbooster';

export default {
    name: 'OTabNav',
    props: {},
    data() {
        return {
            id: 'OTabNav' + this.$getNonceStr(),
            tabNavActiveName: 0,
            list: [],
            scrollBooster: null
        };
    },
    methods: {
        // 用于初始化一些数据
        init() {
            this.initScroll();
            this.initPage();
        },
        initScroll() {
            var id = "#" + this.id;
            var viewport = document.querySelector(id);
            var content = document.querySelector(id + ' .o-tab-nav-scroll');
            var sb = new ScrollBooster({
                viewport: viewport,
                content: content,
                bounce: true,
                mode: 'x',
                onUpdate: (data) => {
                    content.style.transform = `translate(
                  ${-data.position.x}px,
                  ${-data.position.y}px
                )`;
                }
            });
            this.scrollBooster = sb;
        },
        initPage() {
            if (typeof this.config.tabNavList == 'undefined') {
                this.list = [];
            } else {
                this.list = JSON.parse(this.config.tabNavList);
            }
            this.tabNavActiveName = this.config.tabNavActiveName;
            this.show(this.tabNavActiveName);
        },
        dropdownClick(name) {
            this[name]();
        },
        closeAll() {
            // 关闭所有
            this.list = [];
            setTimeout(() => {
                this.$router.push({ path: '/index' });
            }, 1);
        },
        push(to) {
            // 先判断有没有
            let isAdd = true;//是否是新增
            let addIndex = -1;//如果相同，记录相同的下标
            this.list.forEach((item, i) => {
                //console.warn('link:',to.query) 
                
                if (item.to.name == to.name) {
                    if(to.query.code!='' && to.query.code!=undefined && item.to.query.code!=to.query.code){ 
                    
                        return;
                    }
                    // 路由已存在
                    isAdd = false;
                    addIndex = i;
                    return;
                }
                
            });

            // 路由信息不能全存储，定义map仅储存主要部分。
            let map = ['name', 'path', 'query', 'meta'];
            let to_ = {};
            for (let i = 0; i < map.length; i++) {
                to_[map[i]] = to[map[i]];
            }

            // 如果上面的判断需要添加
            if (isAdd) {
                // 插入记录
                this.list.push({
                    title: to.meta.title,
                    to: to_
                });
            } else {
                // 更新to记录
                this.list[addIndex].to = to_;

            }
            this.tabNavActiveName = to.name;
            this.setConfig('tabNavActiveName', this.tabNavActiveName);

        },
        show(to) {

            let pathData = false;
            if (typeof to == 'string') {
                // 用name跳转页面
                this.list.forEach(item => {
                    if (item.to.name == to) {
                        // 跳转
                        pathData = item.to;
                        return;
                    }
                });

            } else {
                // 用json跳转页面
                pathData = to;
            }

            if (pathData) {
                this.tabNavActiveName = pathData.name;
                this.$router.push(pathData);
                this.setConfig('tabNavActiveName', this.tabNavActiveName);
            } else {
                // 报错
            }

        },
        close(i) {
            // 关闭
            if (this.list[i].to.name == this.tabNavActiveName) {


                if (i == 0) {
                    // 第一个
                    if (this.list.length - 1 > 0) {
                        // 还有内容
                        // 显示后面一个
                        this.show(this.list[1].to);
                    } else {
                        // 没了，重置到首页
                        this.$router.push({ path: '/index' });
                    }

                } else {
                    // 不是第一个
                    // 那就显示前面一个
                    this.show(this.list[i - 1].to);
                }

            }

            this.list.splice(i, 1);

        },
        // 用于更新一些数据
        update() {

            this.scrollBooster.updateMetrics();
        },
    },
    // 计算属性
    computed: {
        count() {
            return this.list.length;
        }
    },
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() {
    },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() {
    },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
        this.$nextTick(() => {
            this.init();
            this.push(this.$route);
        });

    },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { },
    // keep-alive 组件激活时调用。
    activated() { },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。此
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {
        list: {
            handler(val, oldVal) {
                this.update();
                this.setConfig('tabNavList', JSON.stringify(this.list));
            },
            deep: true
        },
        $route(to, from) {
            this.push(to);
        }
    },
    // 组件列表
    components: {},
};